export default (to, from, next) => {
  const key = localStorage.getItem('access-token');
  if (key) return next();

  return next({ name: 'home' });
};
